import { Component } from '@angular/core'; //PARA SER UM COMPONENTE TEM QUE TER ESSE IMPORT

import { AuthService } from "../shared/auth.service";

@Component({
    selector: 'navbar',
    //templat: `<p></p>`
    templateUrl: './navbar.component.html'
})

/** CLASSE DO COMPONENT */
export class NavbarComponent{

    public constructor(private authService: AuthService){

    }

}


// WEBPACK FOOTER //
// C:/xampp2/htdocs/angular-front/src/app/navbar/navbar.component.ts